import React, { FunctionComponent } from "react";
import { ICardElementWithChildren } from "backend/model/model";
import TextElement from "reportengine/TextElement";
import Text from "reportengine/Text";
import Slide from "reportengine/Slide";
import DomElement from "reportengine/DomElement";
import Portion from "reportengine/Portion";
import { formatDate } from "utils/utils";
import PerformanceTrend from "components/PerformanceTrend";
import { PerformanceDonut } from "design/components/charts/PerformanceDonut";
import useYearsLastPeriod from "backend/hooks/model/useYearsLastPeriod";
import LastPeriodsName from "../components/LastPeriodName";
import ReportComments from "../components/ReportComment";

const KPISlide = (
  props: React.PropsWithChildren<{
    item: ICardElementWithChildren;
  }>
) => {
  const { item } = props;
  //   const lastPeriod = useYearsLastPeriod(item.period?.name || "");
  return (
    <>
      <Slide index={6}>
        <TextElement slideElement="footer">
          {item["scorecardname"]} (KPI)
        </TextElement>
        <Text slideElement="period">
          <Portion paragraphIndex={0} portionIndex={0}>
            {item.period?.name || ""}
          </Portion>
        </Text>
        <TextElement slideElement="header">{item.parentName}</TextElement>
        <TextElement slideElement="name">{props.item.name}</TextElement>
        <Text slideElement="period_actual_value">
          <Portion portionIndex={2} paragraphIndex={0}>
            {props.item.ACT_YTD_prettyvalue}
          </Portion>
        </Text>
        <ReportComments
          item={props.item}
          slideElement="justification_text"
          justificationDateElement="justification_date"
          justificationOwnerElement="justification_owner"
          justificationOwnerNameElement="justification_owner_name"
        />
        <Text slideElement="period_target_value">
          <Portion portionIndex={2} paragraphIndex={0}>
            {props.item.TAR_YTD_prettyvalue}
          </Portion>
        </Text>
        <Text slideElement="target_achievement_title">
          <Portion portionIndex={1} paragraphIndex={0}>
            {` • ${item.period?.name}`}
          </Portion>
        </Text>
        <LastPeriodsName item={item} slideElement="target_title" />
        <TextElement slideElement="target_value">
          {item.TAR_YEAR_END_YTD_prettyvalue}
        </TextElement>
        <DomElement
          typename="image"
          selector=".element"
          slideElement="target_achievement_donut"
          transform={{
            x: -20,
            width: 240,
            height: 240,
          }}
        >
          <div className="element" style={{ width: "300px", height: "300px" }}>
            <PerformanceDonut
              valueKey="PERF_YTD"
              prettyKey="PERF_YTD_prettyvalue"
              colorKey="rangecolor_PERF_YTD_OPEN"
              disableAnimation
              element={item}
            />
          </div>
        </DomElement>

        <DomElement
          typename="image"
          selector=".highcharts-root"
          slideElement="performance_trend_chart"
          transform={{
            y: 70,
            height: -20,
            width: -30,
          }}
        >
          <div style={{ width: "1090px", height: "300px" }}>
            <PerformanceTrend
              disableAnimation
              width="1090px"
              element={props.item}
              series={[
                {
                  key: "TAR",
                  name: "TARGET",
                  color: "rgb(93,98,104)",
                },
                {
                  key: "ACT",
                  name: "ACTUAL",
                  color: "rgba(38, 166, 242, 0.8)",
                },
              ]}
            />
          </div>
        </DomElement>
      </Slide>
    </>
  );
};

export default KPISlide;
